export type StargateClientOptions = {
  readonly baseUrl: string;
};

export interface IStargateClient {
  fetch(urlPath: string, init?: RequestInit): Promise<Response>;
}

export class StargateClient implements IStargateClient {
  public readonly baseUrl: string;

  public constructor({ baseUrl }: StargateClientOptions) {
    this.baseUrl = baseUrl;
  }

  public async fetch(urlPath: string, init?: RequestInit): Promise<Response> {
    return fetch(this.baseUrl + urlPath, init);
  }
}
